<template>
  <div>
    <va-inner-loading :loading="loader">
      <va-card class="mb-4 delivery-header">
        <div class="d-flex justify--space-between align--center">
          <h1>Доставка</h1>
          <va-button type="button" color="info" @click="showCreateModal = true"
            >Добавить период</va-button
          >
        </div>
      </va-card>
      <delivery-table v-if="delivery_data" :delivery-data="delivery_data" />
    </va-inner-loading>

    <va-modal
      v-model="showCreateModal"
      class="delivery-create-modal"
      hide-default-actions
    >
      <create @close="showCreateModal = false" />
    </va-modal>
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex';
import Create from '../../components/delivery/create.vue';
import deliveryTable from '../../components/delivery/delivery-table.vue';
export default {
  name: 'DeliveryPage',
  components: { deliveryTable, Create },
  data() {
    return {
      showCreateModal: false,
    };
  },
  computed: {
    ...mapState('delivery', ['delivery_data']),
    ...mapGetters({
      loader: 'isLoading',
    }),
  },
  async created() {
    await this.getDeliverySettings({ page: 1 });
  },
  methods: {
    ...mapActions({
      getDeliverySettings: 'delivery/getDeliveryList',
    }),
  },
};
</script>

<style lang="scss">
.delivery-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.delivery-create-modal,
.delivery-edit-modal {
  .va-modal__inner {
    width: 600px;
  }
}
</style>
